import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getProductBrands } from '../../../features/productbrand/services/productBrandService';

// Async thunk to fetch product brands
export const fetchProductBrands = createAsyncThunk(
  'productBrands/fetchProductBrands',
  async (config = {}, { rejectWithValue }) => {
    try {
      const response = await getProductBrands(config);
      const brandData = response?.payload || response || [];
      return Array.isArray(brandData) ? brandData : [];
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch product brands');
    }
  }
);

const productBrandSlice = createSlice({
  name: 'productBrands',
  initialState: {
    brands: [],
    loading: false,
    error: null,
    lastFetched: null,
  },
  reducers: {
    addBrandToStore: (state, action) => {
      state.brands.push(action.payload);
    },
    updateBrandInStore: (state, action) => {
      const index = state.brands.findIndex(b => b.Id === action.payload.Id);
      if (index !== -1) {
        state.brands[index] = action.payload;
      }
    },
    removeBrandFromStore: (state, action) => {
      state.brands = state.brands.filter(b => b.Id !== action.payload);
    },
    resetBrands: (state) => {
      state.brands = [];
      state.error = null;
      state.lastFetched = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProductBrands.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProductBrands.fulfilled, (state, action) => {
        state.loading = false;
        state.brands = action.payload;
        state.lastFetched = Date.now();
      })
      .addCase(fetchProductBrands.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { 
  addBrandToStore, 
  updateBrandInStore, 
  removeBrandFromStore, 
  resetBrands 
} = productBrandSlice.actions;

export default productBrandSlice.reducer;
